module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/btn-sponsor-team.2c374c26.png";